import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import config from '../config';
import fetcher from "../context/fetcher";

export default class AnalyticsApps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            apps: [],
            name: '',
            status: ''
        };

        this.getApps = this.getApps.bind(this);
        this.createApp = this.createApp.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.openApp = this.openApp.bind(this);
        this.stopRowClick = this.stopRowClick.bind(this);
    }

    componentDidMount() {
        this.getApps();
    }

    getApps() {
        fetcher(`${config.API()}analytics-apps`)
            .then(response => {
                const botSync = response.headers.get('X-Analytics-Bot-Sync') || '';
                return response.json().then(apps => ({apps, botSync}));
            })
            .then(({apps, botSync}) => {
                const status = botSync && botSync !== 'ok' ? `Dashboard sync: ${botSync}` : '';
                this.setState({apps, status});
            });
    }

    handleNameChange(e) {
        this.setState({name: e.target.value});
    }

    openApp(appId) {
        this.props.history.push(`/analytics/apps/${encodeURIComponent(appId)}`);
    }

    stopRowClick(e) {
        e.stopPropagation();
    }

    createApp(e) {
        e.preventDefault();
        fetcher(`${config.API()}analytics-apps`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({name: this.state.name})
        })
            .then(response => response.json().then(payload => {
                if (!response.ok)
                    throw new Error(payload.error || payload.msg || 'Create failed');
                return payload;
            }))
            .then(app => {
                const glueStatus = app.crawlerStatus ? `, Glue: ${app.crawlerStatus}` : '';
                const botStatus = app.analyticsBotSync && app.analyticsBotSync.ok === false
                    ? `, Dashboard sync: ${app.analyticsBotSync.error}`
                    : ', dashboards synced';
                this.setState({name: '', status: `App created${glueStatus}${botStatus}`});
                this.getApps();
            })
            .catch(error => this.setState({status: error.message}));
    }

    formatCrawlerLastRun(app) {
        if (!app.crawlerLastRunAt)
            return '';

        return new Date(app.crawlerLastRunAt).toLocaleString();
    }

    render() {
        const rows = this.state.apps.map(app => (
            <tr key={app.appId}
                onClick={() => this.openApp(app.appId)}
                style={{cursor: 'pointer'}}>
                <td className="text-center" style={{width: '50px', padding: 0}}>
                    {app.iconUrl
                        ? <img src={app.iconUrl}
                               alt=""
                               style={{width: '46px', height: '46px', objectFit: 'cover', borderRadius: '6px', display: 'block', margin: '0 auto'}}/>
                        : <span className="d-inline-flex align-items-center justify-content-center text-muted small"
                                style={{width: '46px', height: '46px', border: '1px solid #d8dde8', borderRadius: '6px'}}>
                            {(app.name || app.appId || '?').charAt(0).toUpperCase()}
                        </span>}
                </td>
                <td>{app.name || app.appId}</td>
                <td className="text-nowrap"><code>{app.appId}</code></td>
                <td className="text-nowrap" style={{width: '230px'}}>{app.createdAt ? new Date(app.createdAt).toLocaleString() : ''}</td>
                <td className="text-center" style={{width: '90px'}}>{app.usersCount || 0}</td>
                <td className={app.crawlerStatus === 'error' ? 'text-danger' : 'text-muted'}
                    title={app.crawlerError || ''}>
                    <div>{app.crawlerEnabled === false ? 'off' : (app.crawlerStatus || '-')}</div>
                    {this.formatCrawlerLastRun(app) && <div className="small text-muted">
                        {this.formatCrawlerLastRun(app)}
                    </div>}
                </td>
                <td className="text-center">
                    {app.dashboardUrl
                        ? <a className="btn btn-outline-primary btn-sm text-nowrap"
                             href={app.dashboardUrl}
                             target="_blank"
                             rel="noreferrer"
                             onClick={this.stopRowClick}
                             title="Open dashboards">
                            Dashboards
                        </a>
                        : <span className="text-muted">-</span>}
                </td>
                <td className="text-center">
                    <Link className="btn btn-outline-primary btn-circle btn-sm"
                          to={`/analytics/apps/${encodeURIComponent(app.appId)}`}
                          onClick={this.stopRowClick}
                          title="Edit app">
                        <i className="fa fa-edit"></i>
                    </Link>
                </td>
            </tr>
        ));

        return (
            <div className="card shadow w100">
                <div className="card-header py-3">
                    <h2 className="m-0 font-weight-bold l"> Analytics Apps </h2>
                </div>
                <div className="card-body">
                    <form className="form-inline mb-3" onSubmit={this.createApp}>
                        <input type="text"
                               className="form-control mr-2"
                               placeholder="App name"
                               value={this.state.name}
                               onChange={this.handleNameChange}
                        />
                        <button className="btn btn-icon btn-primary" type="submit">
                            <i className="fas fa-fw fa-plus-square"></i> Create app
                        </button>
                        {this.state.status && <span className="ml-3 text-muted">{this.state.status}</span>}
                    </form>
                    <div className="table-responsive">
                        <table className="dataTable table table-align-middle table-bordered table-sm" width="100%" cellSpacing="0">
                            <thead>
                            <tr>
                                <th style={{width: '50px', padding: 0}}></th>
                                <th>Name</th>
                                <th style={{width: '180px'}}>app_id</th>
                                <th style={{width: '230px'}}>Created</th>
                                <th className="text-center" style={{width: '90px'}}>Users</th>
                                <th style={{width: '120px'}}>Crawler</th>
                                <th className="text-center" style={{width: '150px'}}></th>
                                <th style={{width: '64px'}}></th>
                            </tr>
                            </thead>
                            <tbody>{rows}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}
